import cc from 'classcat';
import { jsxs, jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const lineCls = "_n29l14sw95l";
const arrowHeadContainerCls = "_n29a1vi5fxk";
const arrowHeadAspectRatioCls = "_n29anrqs69";
const arrowHeadCls = "_n29a1rexi2e";
const ArrowShape = ({
  className,
  style,
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: className,
    style: style,
    "data-shape-root": true,
    children: [/*#__PURE__*/jsx("span", {
      className: lineCls,
      style: {
        background: fillColor
      }
    }), /*#__PURE__*/jsx("span", {
      className: arrowHeadContainerCls,
      children: /*#__PURE__*/jsx("span", {
        className: arrowHeadAspectRatioCls,
        children: /*#__PURE__*/jsx("svg", {
          ...svgProps,
          className: cc([svgCls, arrowHeadCls]),
          ref: shapeRef,
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 9 5.2",
          stroke: fillColor,
          children: /*#__PURE__*/jsx("path", {
            fill: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M.8 4.5L4.5.8l3.7 3.7"
          })
        })
      })
    })]
  });
};

export { ArrowShape };
import "./ArrowShape.linaria.module.css";
//# sourceMappingURL=ArrowShape.js.map
